
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"125","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2220"}},[_c('path',{attrs:{"data-name":"Rectangle 2939","fill":"none","d":"M0 0h125v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1354","d":"M74 20H46a4 4 0 00-4 4v44h-5.992a15.977 15.977 0 00-11.051 27.544L49.412 120h75.59V69.39L77.057 21.445A3.972 3.972 0 0074 20z","fill":"#3838d2"}}),_c('g',{attrs:{"data-name":"Group 2219","fill":"#9ea7e9"}},[_c('path',{attrs:{"data-name":"Path 1355","d":"M90 53.738a10 10 0 1010 10 10.017 10.017 0 00-10-10z"}}),_c('path',{attrs:{"data-name":"Path 1356","d":"M74 20H46a4 4 0 00-4 4v44h-5.992a16 16 0 100 32H56a16 16 0 000-32h-6V44h24a4 4 0 004-4V24a4 4 0 00-4-4zM56 76a8 8 0 010 16H36.008a8 8 0 110-16H42v4a4 4 0 008 0v-4z"}})])])])
          )
        }
      }
    